/**
 * Namespace containing user reward status identifiers
 *
 * @description This namespace defines the unique identifiers for different
 * user reward statuses in the system. Each status is assigned a specific
 * BigInt value that corresponds to entries in the database.
 */
export namespace UserRewardStatusId {
  /** Reward that is currently in progress and being worked towards */
  export const InProgress = 1n;

  /** Reward that is locked and requires completing specific tasks to unlock */
  export const Locked = 2n;

  /** Reward that is available and can be claimed by the user */
  export const Available = 3n;

  /** Reward that has been successfully claimed by the user */
  export const Claimed = 4n;

  /** Reward that has expired and can no longer be claimed */
  export const Expired = 5n;

  /** Reward that has been cancelled by the system or administrator */
  export const Cancelled = 6n;
}

/**
 * Type representing valid user reward status ID values
 *
 * @description This type extracts all possible values from the UserRewardStatusId
 * namespace to create a union type of all valid status identifiers
 */
export type UserRewardStatusIdType =
  (typeof UserRewardStatusId)[keyof typeof UserRewardStatusId];
